import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Duration } from '../../../../shared/models';
import { CurrentNumericPipe } from 'src/app/modules/platform/pipes/current-numeric.pipe';

type TimeExtraClass = '' | 'small';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
  imports: [TranslateModule, CurrentNumericPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeComponent {
  @Input() duration: Duration;
  @Input() extraClass: TimeExtraClass = '';
}
